document.addEventListener('DOMContentLoaded', (event) => {
    function currencyFormSubmit(event) {
        event.target.form.submit();
      }
    
      document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
        element.addEventListener('change', currencyFormSubmit);
    });
    const bodySelector = document.querySelector('body')
     
    // colection updates
    if(bodySelector.classList.contains('template-collection')){
       
    }

    // blog article
    if(bodySelector.classList.contains('template-article')){
      const articleImages = Array.from(document.querySelectorAll('.template-article .page-content img'));
      articleImages.map((img) => {
        
        if(img.alt.length > 0){
          img.parentNode.classList.add('has-alt')

          img.insertAdjacentHTML('beforebegin',`<span class="alt-hover-text">${img.alt}</span>`)  
        }
          img.addEventListener('mouseenter', function(){
                
          })
      })
     
    }
    // PLP mobile filters - sidedrawer
    const overlay = document.querySelector('.dark-overlay');
    const html = document.querySelector('html');
    const toggleDrawer = () => {
      const filtersPanel = document.querySelector('.collection-filters');


      if(filtersPanel.classList.contains('open')){
        filtersPanel.classList.remove('open');
        overlay.classList.remove('visible')
        html.classList.remove('scroll-lock')
      }else{
        filtersPanel.classList.add('open');
        overlay.classList.add('visible')
        html.classList.add('scroll-lock')
      }
    }
    const closeBtn = document.querySelector('.collection-filter__close-btn');
    const openBtn = document.querySelector('.filters-plp-btn');
    
    closeBtn.addEventListener('click', toggleDrawer);
    openBtn.addEventListener('click', toggleDrawer);
    overlay.addEventListener('click', toggleDrawer);


    // PLP mobile filters - dropdowns

    
    // Listen for click on the document
    document.addEventListener('click', function (event) {
      event.stopPropagation();
      //Bail if our clicked element doesn't have the class
      if (!event.target.classList.contains('collection-filter__title')) return;

      // Get the target content
      var content = event.target.nextElementSibling;
      const target = event.target;
      if (!content) return;
      
      // Prevent default link behavior
      event.preventDefault();
      
      if(target.classList.contains('active')){
        target.classList.remove('active');
      }
      // If the content is already expanded, collapse it and quit
      if (content.classList.contains('active')) {
        content.classList.remove('active');
        
        return;
      }
    
      // Get all open accordion content, loop through it, and close it
      var accordions = document.querySelectorAll('.collection-filter__inner .accordion-filter-panel.active');
      for (var i = 0; i < accordions.length; i++) {
        accordions[i].classList.remove('active');
      }
      const titles = document.querySelectorAll('.collection-filter__title');
      for (var i = 0; i < titles.length; i++) {
        titles[i].classList.remove('active');
      }
      // Toggle our content
      content.classList.toggle('active');
      target.classList.toggle('active');
    })


  
})



if (!customElements.get("upsell-atc")) {
  class UpsellATC extends HTMLElement {
    constructor() {
      super();
      this.isCart = this.dataset.isCart == 'true'
      this.atcButton = this.querySelector('[data-add-to-cart]')
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }
    attachListeners() {
      if (this.atcButton) {
        this.atcButton.addEventListener('click', this.handleATC.bind(this))
      }
    }
    handleATC(e) {
      e.preventDefault()
      if (!this.atcButton.disabled) {
        fetch("/cart/add.js", {
          body: JSON.stringify(
            {
              quantity: 1,
              id: this.atcButton.dataset.variant
            }
          ),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          method: "post",
        }).then((res) => res.json()).then((data) => {
          if (this.isCart) {
            document.dispatchEvent(new CustomEvent("cart:build"))
            document.dispatchEvent(new CustomEvent("upsell-added", {detail: {id:  this.atcButton.dataset.variant}}))
          } else {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"))
            document.dispatchEvent(new CustomEvent("upsell-added", {detail: {id:  this.atcButton.dataset.variant}}))
          }
        })
      }
    }
  }
  customElements.define("upsell-atc", UpsellATC);
}
